import { APP_VERSION_NO, COURT_NAME } from '../constants/bookingConst';

/**
 * The site footer shared by the guest booking flow, the booking-status
 * screen and the checkout page shell: the club's copyright line plus the
 * build's version number.
 *
 * Extracted into one component because the same markup was repeated in three
 * places, and the version has to read the same in all of them — a footer that
 * shows a different (or no) version depending on which screen a guest is on
 * is worse than not showing it at all, since the number exists so support can
 * ask "what does the footer say?".
 *
 * The version line renders only when REACT_APP_VERSION_NO is actually set
 * (see APP_VERSION_NO), so a build without it looks exactly as this footer
 * did before.
 *
 * @param {Object} props
 * @param {string} [props.courtName] - The club's name (config.courtName).
 *   Falls back to COURT_NAME while config is still loading, or for a club
 *   that never set one.
 * @returns {JSX.Element}
 */
function AppFooter({ courtName }) {
  return (
    <footer className="app-footer">
      <p className="app-footer-copy">© 2026 {courtName || COURT_NAME} Booking System</p>
      {APP_VERSION_NO && <p className="app-footer-version">{APP_VERSION_NO}</p>}
    </footer>
  );
}

export default AppFooter;
